<template><markdown-wrapper><h1 id="affix">Affix <a class="header-anchor" href="#affix">&#128279;</a></h1>
<blockquote>
<p>The affix component toggles <code v-pre>position: fixed</code> on and off, emulating the effect found with <code v-pre>position: sticky</code>.</p>
</blockquote>
<p>The navigation <strong>on the right</strong> is a live demo of the affix component (hidden on mobile devices).</p>
<p><strong>Note</strong>:</p>
<ul>
<li>You must provide CSS for the positioning and width of your affixed content.</li>
<li>Do not use affix on an element contained in a relatively positioned element, such as a pulled or pushed column.</li>
</ul>
<p><ins class="adsbygoogle"
     style="display:block; text-align:center;"
     data-ad-layout="in-article"
     data-ad-format="fluid"
     data-ad-client="ca-pub-4714899946256166"
     data-ad-slot="4603582855"></ins></p>
<h2 id="example">Example <a class="header-anchor" href="#example">&#128279;</a></h2>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">affix</span> <span class="hljs-attr">:offset</span>=<span class="hljs-string">&quot;50&quot;</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">ul</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">li</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">li</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">li</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">li</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">li</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">li</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">ul</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">affix</span>&gt;</span>
</code></pre>
<h1 id="api-reference">API Reference <a class="header-anchor" href="#api-reference">&#128279;</a></h1>
<h2 id="affix-1"><a href="https://github.com/wxsms/uiv/blob/0.x/src/components/affix/Affix.vue">Affix</a> <a class="header-anchor" href="#affix-1">&#128279;</a></h2>
<h3 id="props">Props <a class="header-anchor" href="#props">&#128279;</a></h3>
<div class="table-responsive"><table class="table table-bordered table-hover"><thead>
<tr>
<th>Name</th>
<th>Type</th>
<th>Default</th>
<th>Required</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>offset</code></td>
<td>Number</td>
<td>0</td>
<td></td>
<td>Pixels to offset from screen when calculating position of scroll.</td>
</tr>
</tbody>
</table></div><h3 id="slots">Slots <a class="header-anchor" href="#slots">&#128279;</a></h3>
<div class="table-responsive"><table class="table table-bordered table-hover"><thead>
<tr>
<th>Name</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>default</code></td>
<td>The affix body.</td>
</tr>
</tbody>
</table></div><h3 id="events">Events <a class="header-anchor" href="#events">&#128279;</a></h3>
<div class="table-responsive"><table class="table table-bordered table-hover"><thead>
<tr>
<th>Name</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>affix</code></td>
<td>This event fires immediately before the element has been affixed.</td>
</tr>
<tr>
<td><code v-pre>affixed</code></td>
<td>This event is fired after the element has been affixed.</td>
</tr>
</tbody>
</table></div></markdown-wrapper></template><script>export default {components:{}}</script>